import type { TOC } from '@ember/component/template-only';
import { fn } from '@ember/helper';
import changesetGet from 'ember-changeset/helpers/changeset-get';
import changesetSet from 'ember-changeset/helpers/changeset-set';
import ValidatedField, {
  type S as ValidatedFieldSig
} from 'ui-kit/components/validated-field';
import DatetimePicker, {
  type S as DateTimePickerSig
} from '../datetime-picker';

interface Signature {
  Args: Pick<
    DateTimePickerSig['Args'],
    'disabled' | 'isReadOnly' | 'isMandatory' | 'labelName'
  > &
    Pick<ValidatedFieldSig['Args'], 'changeset' | 'propertyName'> & {};
}

export default <template>
  <ValidatedField
    @propertyName={{@propertyName}}
    @changeset={{@changeset}}
    @errorClass='error-validated-input-display'
  >
    <DatetimePicker
      @propertyName={{@propertyName}}
      @selected={{changesetGet @changeset @propertyName}}
      @isReadOnly={{@isReadOnly}}
      @disabled={{@disabled}}
      @labelName={{@labelName}}
      @isMandatory={{@isMandatory}}
      @onChange={{fn (changesetSet @changeset @propertyName)}}
    />
  </ValidatedField>
</template> satisfies TOC<Signature>;
